<template>
    <div>
        <cover-image
            :youtube-id="shoot.previewYoutubeId"
            :background-color="shoot.primaryColor"
            :color="shoot.primaryColor"
            :secondary-color="shoot.secondaryColor"
            :title="shoot.title"
            :subtitle="shoot.date"
            action-text="Video ansehen"
            action-path="#video" main left>

            <template #buttons>
                <v-btn to="/video-shoots" :color="shoot.secondaryColor ?? undefined" size="x-large" :prepend-icon="mdiArrowLeft">
                    Alle Videos
                </v-btn>
            </template>

            <template #description>
                <shoot-artist-list :shoot="shoot"/>
            </template>

        </cover-image>

        <div id="video">
            <iframe v-if="shoot.previewYoutubeId" width="100%" :style="{height: '100vh', width: '100vw'}" :src="`https://www.youtube.com/embed/${shoot.previewYoutubeId}?rel=0&modestbranding=1&mute=1&showinfo=0&controls=0&autoplay=1&loop=1`" frameborder="0" allow="autoplay"/>
        </div>

        <app-footer/>

    </div>
</template>

<script setup lang="ts">
import {mdiArrowLeft} from "@mdi/js";
import {VideoShoot} from "../../types/models/VideoShoot";

const {params} = useRoute();

const {data: shoot}: {data: VideoShoot} = await useApiFetch('getVideoShoot', [
    'title',
    'slug',
    'date',
    'primaryColor',
    'secondaryColor',
    'previewYoutubeId',
    'cameraArtist {name url}',
    'makeupArtist {name url}',
    'hairArtist {name url}',
    'voiceArtist {name url}',
    'castingAgency {name url}',
], `where: {slug: "${params.shoot}"}`);

useMeta({
    title: shoot.title,
    description: `Betrachte das Video aus dem Dreh "${shoot.title}".`,
})

</script>